import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        archived: {
            minWidth: theme.spacing(10),
        },
    }
})
